module.exports = __webpack_public_path__ + "img/vertical_4_6_7016.d07439be.png";